<!-- src/views/BaZi.vue -->
<template>
  <a-layout style="height: 100vh" class="bazi-container">
    <!-- 左侧排盘结果 - 占4/5宽度 -->
    <a-layout-content style="background: #1e1e2f; padding: 20px; width: 80%; overflow-y: auto; color: #fff;">
      <div v-if="data" class="bazi-result">
        <table class="bazi-table">
          <tbody>
            <!-- 基本信息 -->
            <tr>
              <td class="label-cell">出生：</td>
              <td colspan="10">{{ data.solar_birth }}<br><br>本地真太阳时:{{ trueSolarTime }} 本地太平洋时:{{ meanSolarTime
              }}<br><br>{{ data.lunar_birth }}</td>

            </tr>
            <tr>
              <td class="label-cell">节气：</td>
              <td colspan="10">{{ data.prev_jie_qi }}<br>{{ data.next_jie_qi }}</td>
            </tr>
            <tr>
              <td class="label-cell">{{ data.ba_zi_title }}：</td>
              <td>年柱</td>
              <td>月柱</td>
              <td>日柱</td>
              <td>时柱</td>
              <td>大运</td>
              <td>流年</td>
              <td>流月</td>
              <td>流日</td>
              <td>流时</td>
            </tr>
            <!-- 十神 -->
            <tr>
              <td class="label-cell">主星</td>
              <td :class="getShiShenClass(data.ba_zi.year_shi_shen_gan)">{{ data.ba_zi.year_shi_shen_gan }}</td>
              <td :class="getShiShenClass(data.ba_zi.month_shi_shen_gan)">{{ data.ba_zi.month_shi_shen_gan }}</td>
              <td>{{ data.ri_gan }}</td>
              <td :class="getShiShenClass(data.ba_zi.time_shi_shen_gan)">{{ data.ba_zi.time_shi_shen_gan }}</td>
              <td :class="getShiShenClass(data.current_yun?.da_yun_shi_shen)">{{ data.current_yun?.da_yun_shi_shen }}
              </td>
              <td :class="getShiShenClass(data.current_yun?.liu_nian_shi_shen)">{{ data.current_yun?.liu_nian_shi_shen
              }}</td>
              <td :class="getShiShenClass(data.current_yun?.liu_yue_shi_shen)">{{ data.current_yun?.liu_yue_shi_shen }}
              </td>
              <td :class="getShiShenClass(data.current_yun?.liu_ri_shi_shen)">{{ data.current_yun?.liu_ri_shi_shen }}
              </td>
              <td :class="getShiShenClass(data.current_yun?.liu_shi_shi_shen)">{{ data.current_yun?.liu_shi_shi_shen }}
              </td>
            </tr>
            <!-- 天干 -->
            <tr>
              <td class="label-cell">天干</td>
              <td>{{ data.ba_zi.year_gan }}</td>
              <td>{{ data.ba_zi.month_gan }}</td>
              <td>{{ data.ba_zi.day_gan }}</td>
              <td>{{ data.ba_zi.time_gan }}</td>
              <td>{{ data.current_yun?.da_yun_gan_zhi?.slice(0, 1) }}</td>
              <td>{{ data.current_yun?.liu_nian_gan_zhi?.slice(0, 1) }}</td>
              <td>{{ data.current_yun?.liu_yue_gan_zhi?.slice(0, 1) }}</td>
              <td>{{ data.current_yun?.liu_ri_gan_zhi?.slice(0, 1) }}</td>
              <td>{{ data.current_yun?.liu_shi_gan_zhi?.slice(0, 1) }}</td>
            </tr>
            <!-- 地支 -->
            <tr>
              <td class="label-cell">地支</td>
              <td>{{ data.ba_zi.year_zhi }}</td>
              <td>{{ data.ba_zi.month_zhi }}</td>
              <td>{{ data.ba_zi.day_zhi }}</td>
              <td>{{ data.ba_zi.time_zhi }}</td>
              <td>{{ data.current_yun?.da_yun_gan_zhi?.slice(1) }}</td>
              <td>{{ data.current_yun?.liu_nian_gan_zhi?.slice(1) }}</td>
              <td>{{ data.current_yun?.liu_yue_gan_zhi?.slice(1) }}</td>
              <td>{{ data.current_yun?.liu_ri_gan_zhi?.slice(1) }}</td>
              <td>{{ data.current_yun?.liu_shi_gan_zhi?.slice(1) }}</td>
            </tr>
            <!-- 藏干 -->
            <tr>
              <td class="label-cell">藏干</td>
              <td class="hide-gan-cell">{{ formatHideGan(data.ba_zi.year_shi_shen_zhi) }}</td>
              <td class="hide-gan-cell">{{ formatHideGan(data.ba_zi.month_shi_shen_zhi) }}</td>
              <td class="hide-gan-cell">{{ formatHideGan(data.ba_zi.day_shi_shen_zhi) }}</td>
              <td class="hide-gan-cell">{{ formatHideGan(data.ba_zi.time_shi_shen_zhi) }}</td>
              <td class="hide-gan-cell">{{ formatHideGan(data.current_yun?.da_yun_shi_shen_zhi) }}</td>
              <td class="hide-gan-cell">{{ formatHideGan(data.current_yun?.liu_nian_shi_shen_zhi) }}</td>
              <td class="hide-gan-cell">{{ formatHideGan(data.current_yun?.liu_yue_shi_shen_zhi) }}</td>
              <td class="hide-gan-cell">{{ formatHideGan(data.current_yun?.liu_ri_shi_shen_zhi) }}</td>
              <td class="hide-gan-cell">{{ formatHideGan(data.current_yun?.liu_shi_shi_shen_zhi) }}</td>
            </tr>
            <!-- 地势(星运) -->
            <tr>
              <td class="label-cell">地势(星运)：</td>
              <td>{{ data.ba_zi.year_di_shi || '-' }}</td>
              <td>{{ data.ba_zi.month_di_shi || '-' }}</td>
              <td>{{ data.ba_zi.day_di_shi || '-' }}</td>
              <td>{{ data.ba_zi.time_di_shi || '-' }}</td>
              <td>{{ data.current_yun?.da_yun_di_shi || '-' }}</td>
              <td>{{ data.current_yun?.liu_nian_di_shi || '-' }}</td>
              <td>{{ data.current_yun?.liu_yue_di_shi || '-' }}</td>
              <td>{{ data.current_yun?.liu_ri_di_shi || '-' }}</td>
              <td>{{ data.current_yun?.liu_shi_di_shi || '-' }}</td>
            </tr>
            <!-- 自坐 -->
            <tr>
              <td class="label-cell">自坐：</td>
              <td>{{ data.ba_zi.year_zi_zuo || '-' }}</td>
              <td>{{ data.ba_zi.month_zi_zuo || '-' }}</td>
              <td>{{ data.ba_zi.day_zi_zuo || '-' }}</td>
              <td>{{ data.ba_zi.time_zi_zuo || '-' }}</td>
              <td>{{ data.current_yun?.da_yun_zi_zuo || '-' }}</td>
              <td>{{ data.current_yun?.liu_nian_zi_zuo || '-' }}</td>
              <td>{{ data.current_yun?.liu_yue_zi_zuo || '-' }}</td>
              <td>{{ data.current_yun?.liu_ri_zi_zuo || '-' }}</td>
              <td>{{ data.current_yun?.liu_shi_zi_zuo || '-' }}</td>
            </tr>
            <!-- 空亡 -->
            <tr>
              <td class="label-cell">空亡：</td>
              <td class="kong-wang-cell">{{ formatKongWang(data.ba_zi.year_kong_wang) }}</td>
              <td class="kong-wang-cell">{{ formatKongWang(data.ba_zi.month_kong_wang) }}</td>
              <td class="kong-wang-cell">{{ formatKongWang(data.ba_zi.day_kong_wang) }}</td>
              <td class="kong-wang-cell">{{ formatKongWang(data.ba_zi.time_kong_wang) }}</td>
              <td class="kong-wang-cell">{{ formatKongWang(data.current_yun?.da_yun_kong_wang) }}</td>
              <td class="kong-wang-cell">{{ formatKongWang(data.current_yun?.liu_nian_kong_wang) }}</td>
              <td class="kong-wang-cell">{{ formatKongWang(data.current_yun?.liu_yue_kong_wang) }}</td>
              <td class="kong-wang-cell">{{ formatKongWang(data.current_yun?.liu_ri_kong_wang) }}</td>
              <td class="kong-wang-cell">{{ formatKongWang(data.current_yun?.liu_shi_kong_wang) }}</td>
            </tr>
            <!-- 纳音 -->
            <tr>
              <td class="label-cell">纳音：</td>
              <td>{{ data.ba_zi.year_na_yin || '-' }}</td>
              <td>{{ data.ba_zi.month_na_yin || '-' }}</td>
              <td>{{ data.ba_zi.day_na_yin || '-' }}</td>
              <td>{{ data.ba_zi.time_na_yin || '-' }}</td>
              <td>{{ data.current_yun?.da_yun_na_yin || '-' }}</td>
              <td>{{ data.current_yun?.liu_nian_na_yin || '-' }}</td>
              <td>{{ data.current_yun?.liu_yue_na_yin || '-' }}</td>
              <td>{{ data.current_yun?.liu_ri_na_yin || '-' }}</td>
              <td>{{ data.current_yun?.liu_shi_na_yin || '-' }}</td>
            </tr>
            <!-- 起运 -->
            <tr>
              <td class="label-cell">起运：</td>
              <td colspan="10">{{ data.start_yun }}</td>
            </tr>
            <!-- 大运表头 -->
            <tr class="header-row">
              <td class="label-cell">周岁：</td>
              <td v-for="yun in data.da_yun" :key="yun.start_year">{{ yun.start_age || '-' }}</td>
            </tr>
            <tr class="header-row">
              <td class="label-cell">换运：</td>
              <td v-for="yun in data.da_yun" :key="yun.start_year">{{ yun.start_year }}</td>
            </tr>
            <tr class="header-row">
              <td class="label-cell">十神：</td>
              <td v-for="yun in data.da_yun" :key="yun.start_year" :class="getShiShenClass(yun.shi_shen)">{{
                yun.shi_shen || '-' }}</td>
            </tr>
            <tr class="header-row">
              <td class="label-cell">运程：</td>
              <td v-for="yun in data.da_yun" :key="yun.start_year">{{ yun.gan_zhi || '童限' }}</td>
            </tr>
            <!-- 流年 -->
            <tr v-for="(row, index) in getLiuNianRows(data.da_yun)" :key="index">
              <td class="label-cell" v-if="index === 0">流年：</td>
              <td class="label-cell" v-else></td>
              <td v-for="(cell, cellIndex) in row" :key="cellIndex" :class="{ 'current': isCurrentYear(cell?.year) }">
                {{ cell ? `${cell.year} ${cell.gan_zhi} ${cell.shi_shen} ` : '' }}
              </td>
            </tr>
          </tbody>
        </table>
        <!-- 在流年后面添加流月流日组件 -->
        <LiuYueLiuRi :liu-yue-data="data.current_liu_yue || []" :liu-ri-data="data.current_liu_ri || []" />

      </div>
      <div v-else class="empty-result">
        <a-empty description="请填写右侧信息生成排盘">
          <template #image>
            <div style="font-size: 48px;">📅</div>
          </template>
        </a-empty>
      </div>
      <!-- 添加神煞组件 -->
      <ShenSha v-if="data" :gans="getGansForShenSha()" :zhis="getZhisForShenSha()" />
      <!-- 在布局内容中添加七政四余组件 -->
      <QiZhengSiYu v-if="data" :birthDateTime="birthDateTime" :gender="gender" :longitude="longitude"
        :latitude="latitude" :timezone="timezone" />
    </a-layout-content>

    <!-- 右侧输入区域 -->
    <a-layout-sider width="20%" style="background: #2c2c3c; padding: 20px; box-shadow: -2px 0 5px rgba(0,0,0,0.5);">
      <div style="max-width: 100%;">
        <h2 style="color: #FFFFFF; margin-bottom: 24px; text-align: center;">排盘参数</h2>
        <a-form layout="vertical">
          <a-form-item label="出生时间" required>
            <a-date-picker v-model:value="birthDateTime" show-time style="width: 100%" format="YYYY-MM-DD HH:mm"
              placeholder="请选择出生日期和时间" />
          </a-form-item>
          <a-form-item label="历法">
            <a-radio-group v-model:value="isLunar" button-style="solid">
              <a-radio-button :value="0">阳历</a-radio-button>
              <a-radio-button :value="1">阴历</a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="性别">
            <a-radio-group v-model:value="gender" button-style="solid">
              <a-radio-button :value="1">男</a-radio-button>
              <a-radio-button :value="0">女</a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="子时处理">
            <a-radio-group v-model:value="sect" button-style="solid">
              <a-radio-button :value="1">当天</a-radio-button>
              <a-radio-button :value="2">次日</a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="时区">
            <a-select v-model:value="timezone" style="width: 100%" :options="timezoneOptions"
              :fieldNames="{ label: 'title', value: 'value' }"></a-select>
          </a-form-item>
          <a-form-item label="经度">
            <a-input-number v-model:value="longitude" :min="-180" :max="180" :step="0.1" style="width: 100%" />
          </a-form-item>
          <a-form-item label="纬度">
            <a-input-number v-model:value="latitude" :min="-90" :max="90" :step="0.1" style="width: 100%" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" block @click="fetchData" :loading="loading" style="height: 40px;">
              生成排盘
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-layout-sider>
  </a-layout>
</template>

<script setup>
import axios from '@/utils/axios';
import { timezoneOptions } from '@/utils/timezone.js';
import { message } from 'ant-design-vue';
import dayjs from 'dayjs';
import { ref, watch } from 'vue';

import '@/utils/paipan.js';
import LiuYueLiuRi from './LiuYueLiuRi.vue';
import QiZhengSiYu from './QiZhengSiYu.vue';
import ShenSha from './ShenSha.vue';


const birthDateTime = ref(dayjs('1999-09-09 00:00'))
const isLunar = ref(0)
const gender = ref(1)
const sect = ref(1)
const data = ref(null)
const loading = ref(false)
const refreshShenSha = ref(0)

const longitude = ref(106.769)
const latitude = ref(31.8515)
const timezone = ref('Asia/Shanghai')

const trueSolarTime = ref('');
const meanSolarTime = ref('');
const trueSolarObj = ref(null)

const formatTime = (timeArray) => {
  if (!timeArray || !Array.isArray(timeArray)) return '无效时间';
  return timeArray
    .map(num => String(num).padStart(2, '0'))
    .join('-')
    .replace(/(\d+)-(\d+)-(\d+)-(\d+)-(\d+)-(\d+)/, '$1-$2-$3 $4:$5:$6');
};

const calculateSolarTimes = (year, month, day, hour, minute, second, lng, lat) => {
  try {
    const result = window.p?.trueSolar?.(year, month, day, hour, minute, second, lng, lat);

    trueSolarTime.value = formatTime(result?.zty);
    meanSolarTime.value = formatTime(result?.pty);
    trueSolarObj.value = {
      year: result.zty[0],
      month: result.zty[1],
      day: result.zty[2],
      hour: result.zty[3],
      minute: result.zty[4],
      second: result.zty[5]
    }
  } catch (error) {
    console.error('计算失败:', error);
    trueSolarTime.value = '计算错误';
    meanSolarTime.value = '计算错误';
  }
};

watch(
  [birthDateTime, longitude, latitude],
  ([date, lng, lat]) => {
    if (!date) return;

    calculateSolarTimes(
      date.year(),
      date.month() + 1,
      date.date(),
      date.hour(),
      date.minute(),
      date.second(),
      lng,
      lat
    );
  },
  { immediate: true }
);

const formatHideGan = (hideGan) => {
  if (!hideGan || !Array.isArray(hideGan)) return ''
  return hideGan.join('\n')
}

const formatKongWang = (kongWang) => {
  if (!kongWang || !Array.isArray(kongWang)) return '-'
  return kongWang.join(' ')
}

const getShiShenClass = (ss) => {
  if (!ss) return ''
  if (ss.includes('财')) return 'ss-cai'
  if (ss.includes('官') || ss.includes('杀')) return 'ss-guan'
  if (ss.includes('印')) return 'ss-yin'
  if (ss.includes('比') || ss.includes('劫')) return 'ss-bi'
  if (ss.includes('食') || ss.includes('伤')) return 'ss-shi'
  return ''
}

const getLiuNianRows = (daYun) => {
  if (!daYun) return []
  const maxLiuNian = Math.max(...daYun.map(yun => yun.liu_nian?.length || 0))
  const rows = []
  for (let i = 0; i < maxLiuNian; i++) {
    const row = daYun.map(yun => yun.liu_nian?.[i] || null)
    rows.push(row)
  }
  return rows
}

const isCurrentYear = (year) => year === dayjs().year()

const fetchData = async () => {
  if (!birthDateTime.value) {
    message.warning('请选择出生日期和时间')
    return
  }
  if (!trueSolarObj.value) {
    message.error('请等待天文时间计算完成')
    return
  }

  loading.value = true
  try {
    const res = await axios.post('/api/rili/v3/bazi/paipan', null, {
      params: {
        year: trueSolarObj.value.year,
        month: trueSolarObj.value.month,
        day: trueSolarObj.value.day,
        hour: trueSolarObj.value.hour,
        minute: trueSolarObj.value.minute,
        gender: gender.value,
        sect: sect.value,
        isLunar: isLunar.value
      }
    })
    data.value = res.data.data
    refreshShenSha.value += 1
    message.success('排盘成功')
  } catch (e) {
    console.error(e)
    message.error('排盘失败，请稍后重试')
  } finally {
    loading.value = false
  }
}

const getGansForShenSha = () => {
  if (!data.value) return []
  return [
    data.value.ba_zi.year_gan,
    data.value.ba_zi.month_gan,
    data.value.ba_zi.day_gan,
    data.value.ba_zi.time_gan,
    data.value.current_yun?.da_yun_gan_zhi?.slice(0, 1) || '',
    data.value.current_yun?.liu_nian_gan_zhi?.slice(0, 1) || '',
    data.value.current_yun?.liu_yue_gan_zhi?.slice(0, 1) || '',
    data.value.current_yun?.liu_ri_gan_zhi?.slice(0, 1) || '',
    data.value.current_yun?.liu_shi_gan_zhi?.slice(0, 1) || ''
  ]
}

const getZhisForShenSha = () => {
  if (!data.value) return []
  return [
    data.value.ba_zi.year_zhi,
    data.value.ba_zi.month_zhi,
    data.value.ba_zi.day_zhi,
    data.value.ba_zi.time_zhi,
    data.value.current_yun?.da_yun_gan_zhi?.slice(1) || '',
    data.value.current_yun?.liu_nian_gan_zhi?.slice(1) || '',
    data.value.current_yun?.liu_yue_gan_zhi?.slice(1) || '',
    data.value.current_yun?.liu_ri_gan_zhi?.slice(1) || '',
    data.value.current_yun?.liu_shi_gan_zhi?.slice(1) || ''
  ]
}

watch(timezone, (newVal) => {
  const selected = timezoneOptions.value.find(item => item.value === newVal)
  if (selected) {
    longitude.value = selected.lng
    latitude.value = selected.lat
  }
})
</script>

<style scoped>
/* 样式保持不变 */
.bazi-container {
  font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
}

:deep(.ant-form-item-label > label) {
  color: #FFA500 !important;
}

:deep(.ant-form-item-required::before) {
  color: #FF0000 !important;
}

[data-theme="dark"] ::-webkit-scrollbar-thumb {
  background: #434343;
}

[data-theme="dark"] ::-webkit-scrollbar-track {
  background: #1f1f1f;
}

.bazi-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  border: 1px solid #444;
  color: #fff;
}

.bazi-table td {
  padding: 8px 6px;
  border: 1px solid #444;
  text-align: center;
  white-space: pre-line;
}

.label-cell {
  font-weight: bold;
  background-color: #2a2a3c;
  text-align: right;
  width: 60px;
}

.header-row {
  background-color: #33334d;
  font-weight: bold;
}

.current {
  background-color: #444466;
  font-weight: bold;
}

.ss-cai {
  color: #ff4d4f;
}

.ss-guan {
  color: #40a9ff;
}

.ss-yin {
  color: #73d13d;
}

.ss-bi {
  color: #ffa940;
}

.ss-shi {
  color: #9254de;
}

.hide-gan-cell {
  line-height: 1.5;
  padding: 4px 6px;
}

.kong-wang-cell {
  line-height: 1.5;
  padding: 4px 6px;
  font-size: 13px;
}

.empty-result {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 40px;
  color: #fff;
}
</style>